import React, { useEffect, useState, createContext } from 'react'

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { useLocation } from 'react-router-dom';

import SearchStringOrIntReq5 from "../../../Classes/Models/Requests/SearchStringOrIntReq"
import SessionsApi from "../../../Classes/API/Administration/SessionsApi"

import AccSessionDetailsCard from "./AccSessionDetailsCard"
import AccSessionTherapists from "./AccSessionTherapists/Index"

import AccSessionFacilities from "./AccSessionFacilities/Index"

import PatientHistory from "./PatientHistory/index"
import { useContext } from 'react';
import { UserContext } from 'App';

const index = ({ }) => {

  const User = useContext(UserContext)
  console.log("UserData in AccSessionDetails:", User)
  const { state } = useLocation();
  const [Session, setSession] = useState({})
  const [IsLoaded, setIsLoaded] = useState(false)

  let req = new SearchStringOrIntReq5()

  useEffect(async () => {
    if (Object.keys(Session).length < 1 || !IsLoaded) {
      await GetSessionData(state.SearchSession.id)
    }

  }, [IsLoaded])

  useEffect(() => {

    if (Object.keys(Session).length > 0) {
      setIsLoaded(true);
    }
    else {
      setIsLoaded(false)
    }

  }, [Session])

  const GetSessionData = async (id) => {
    req.SearchInt = id;
    let res = await SessionsApi.GetAccountingSessionById(req)
    if (res.status == "Success") {
      // let metadataClone  = Object.assign({}, res.data)
      setSession(res.data)
    }
  }
  
  if (!IsLoaded || Object.keys(User).length < 1) {
    return (<div>Loading...</div>)
  }
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <AccSessionDetailsCard CurrentUser={User} Session={Session} setIsLoaded={setIsLoaded} />

      {/* {
        (["Admin", "Owner", "HeadAccounting"].includes(User.userType) || User.userType == "AccountingEmployee" || User.userType == "AppointmentEmployee") && (
          
          <>
          <AccSessionTherapists Session={Session} setIsLoaded={setIsLoaded} />
            {
              User.userType != "AccountingEmployee" &&
              <AccSessionFacilities Session={Session} setIsLoaded={setIsLoaded} />
            }
          </>
        )
      } */}

      {/* <PatientHistory CurrentUser={User} Session={Session} /> */}


    </DashboardLayout>
  )
}

export default index